import React, { useEffect, useState } from "react";
import { Whatsapp } from "../../../../../../assets/media/icons";
import Button from "../../../../../../components/ui/Button";

interface ResendOtpProps {
  onPress: (messageChannel: string) => void;
}

const ResendOtp: React.FC<ResendOtpProps> = ({ onPress }) => {
  const [seconds, setSeconds] = useState(30);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setIsVisible(true), 30000);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    if (seconds > 0) {
      const intervalId = setInterval(
        () => setSeconds((prev) => prev - 1),
        1000
      );
      return () => clearInterval(intervalId);
    }
  }, [seconds]);

  const handleOTPRequest = (channel: string) => {
    setSeconds(30);
    setIsVisible(false);
    onPress(channel);
  };

  return (
    <div>
      <span className="text-base text-center block w-full text-secondary">
        {isVisible ? "Send again" : `Resend OTP in  ${seconds}`}
      </span>
      {isVisible && (
        <div className="flex justify-center mt-4 gap-4">
          <Button
            icon="sms"
            type="outlined"
            className="bg-white rounded-2xl border py-2 px-3 border-light-grey text-primary"
            onClick={() => handleOTPRequest("sms")}
          >
            SMS
          </Button>
          <button
            onClick={() => handleOTPRequest("whatsapp")}
            className="flex items-center rounded-2xl justify-center  py-2 px-3 font-medium bg-white hover:bg-orange rounded-xl text-primary border border-primary"
          >
            <Whatsapp className="w-6 h-6 mr-4 fill-current" />
            <span className="font-medium text-primary">Whatsapp</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ResendOtp;
